/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fd86807b2ed510056e432c7dc17820df89211edf";
